<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-col :span="6">
        <el-form-item label="房产" prop="propertyId">
          <el-select
            @click.native="handleSelectClick"
            :value="propertyName"
            ref="propertySelectRef1"
            placeholder="请选择房产"
            style="width: 100%;"
            clearable
            @clear="clearProperty"
          >
            <el-option :value="propertyName" :label="propertyName">
              <el-tree
                ref="propertyTreeRef1"
                node-key="id"
                :props="treeProps"
                :load="lazyLoadPropertyTree"
                lazy
                @node-click="propertyNodeTreeClick1"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="费用种类" prop="feeSortId">
          <el-select
            v-model="query.feeSortId"
            placeholder="请选择费项"
            style="width: 100%;"
            clearable
          >
            <el-option
              style="padding-left: 10px;"
              v-for="item in feeSortList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="费项名称">
          <el-input
            placeholder="可输入开头部分名称"
            size="small"
            clearable
            v-model="query.feeItemName"
          />
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="启用状态">
          <el-select v-model="query.validFlag" clearable placeholder="请选择">
            <el-option
              v-for="item in validFlagSelection"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4" offset="1">
        <el-button type="primary" icon="el-icon-search" @click="submitSearchForm">搜索</el-button>
        <el-button icon="el-icon-delete" @click="searchReset">清空</el-button>
      </el-col>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.feeitemset_add"
          @click="openAeform('add')"
          >新 增
        </el-button>
        <!--<el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          v-if="permission.feeitemset_delete"
          @click="handleDelete"
          >删 除
        </el-button>-->
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openAeform('view', scope.row.id)"
          >查看</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-edit"
          @click="openAeform('edit', scope.row.id)"
          v-show="scope.row.validFlag === 0"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-remove-outline"
          @click="stopUse(scope.row)"
          v-show="scope.row.validFlag !== 2"
          style="color: #ff0000;"
          >停用</el-button
        >
        <el-button
          type="text"
          size="small"
          icon="el-icon-document-copy"
          @click="openAeform('copy', scope.row.id)"
          v-show="scope.row.validFlag === 2"
          style="color: #281c26;"
          >复制</el-button
        >
        <!--<el-button
          type="text"
          size="small"
          icon="el-icon-delete"
          @click="rowDel(scope.row)"
          style="color: #ff0000;"
          >删除</el-button
        >-->
      </template>
    </avue-crud>
    <el-dialog
      :title="aeformTitle"
      :visible.sync="showAeform"
      v-if="showAeform"
      :modal-append-to-body="false"
      width="60%"
    >
      <!-- 使用组件 -->
      <aeform :operateType="operateType" :dataId="dataId" @closeAeform="closeAeform"></aeform>
      <router-link to=""></router-link>
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
  getLabelName,
  getProperTree,
  stopUse,
} from '@/api/v4ward/itemset/feeitemset';
import { getTreeChildrenPowerNode } from '@/api/v4ward/property/baseproperty';
import { getDictionaryWithIntKey } from '../../../api/common';
import { mapGetters } from 'vuex';
import aeform from './feeitemset-form';
const DIC = {
  VALID_FLAG: [
    {
      label: '未启用',
      value: 0,
    },
    {
      label: '已启用',
      value: 1,
    },
    {
      label: '已停用',
      value: 2,
    },
  ],
};
export default {
  components: {
    aeform,
  },
  data() {
    return {
      form: { propertyId: '' },
      query: {
        validFlag: 1,
      },
      loading: true,
      properIds: [],
      resetSearch: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      showAeform: false,
      aeformTitle: '新增',
      operateType: 'add',
      dataId: '',
      selectionList: [],
      feeSortList: [],
      validFlagSelection: DIC.VALID_FLAG,
      filterText: '',
      treeTrackId: '',
      propertyName: '',
      treeProps: {
        //标题
        label: 'objectFullName',
        //值
        value: 'id',
        //子节点
        children: 'zones',
        //是否叶子节点
        isLeaf: 'isLeaf',
        //本节点类型key值
        objectType: 'objectType',
        //本节点类型名
        objectTypeName: 'objectTypeName',
      },
      option: {
        height: 'auto',
        calcHeight: 50,
        tip: false,
        border: true,
        index: false,
        addBtn: false,
        viewBtn: false,
        delBtn: false,
        editBtn: false,
        // selection: true,
        labelWidth: 130,
        menuWidth: 180,
        align: 'center',
        column: [
          /*          {
            label: '费项设置表ID',
            prop: 'id',
            hide: true,
            span: 8,
          },*/
          {
            label: '房产类型',
            prop: 'objectTypeName',
            width: 80,
            hide: true,
            span: 8,
          },
          {
            label: '小区名称',
            prop: 'objectName',
            overHidden: true,
            span: 8,
          },
          {
            label: '费用种类',
            prop: 'feeSort',
            hide: true,
            span: 8,
            type: 'select',
            editDisabled: true,
            dataType: 'number',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=fee_sort',
          },
          {
            label: '费项编码',
            prop: 'feeItemCode',
            overHidden: true,
          },
          {
            label: '费项名称',
            prop: 'feeItemName',
            overHidden: true,
          },
          {
            label: '计费方式',
            prop: 'feeType',
            span: 8,
            type: 'select',
            dataType: 'number',
            width: 105,
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=fee_type',
          },
          {
            label: '周期数',
            width: 80,
            prop: 'feeCycleNum',
            hide: true,
          },
          {
            label: '收费周期',
            width: 90,
            prop: 'feeCycleName',
          },
          {
            label: '是否启用',
            prop: 'validFlag',
            type: 'select',
            //search: true,
            width: 85,
            dicData: DIC.VALID_FLAG,
          },
          {
            label: '启用日期',
            prop: 'useTime',
            span: 8,
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '停用日期',
            prop: 'stopTime',
            span: 8,
            type: 'date',
            format: 'yyyy-MM-dd',
            width: 100,
          },
          {
            label: '超期天数',
            width: 80,
            prop: 'delayDays',
          },
          {
            label: '滞纳金比%',
            prop: 'delayRate',
            width: 95,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feeitemset_add, false),
        viewBtn: this.vaildData(this.permission.feeitemset_view, false),
        delBtn: this.vaildData(this.permission.feeitemset_delete, false),
        editBtn: this.vaildData(this.permission.feeitemset_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    //this.initData();
  },
  mounted() {
    this.initSelectList();
  },
  methods: {
    handleSelectClick() {
      setTimeout(() => {
        document.querySelector(
          'body > div.el-select-dropdown.el-popper > div.el-scrollbar > div.el-scrollbar__bar.is-vertical'
        ).style.display = 'none';
      }, 0);
    },
    initSelectList() {
      getDictionaryWithIntKey('fee_sort').then((data) => {
        this.feeSortList = data.data;
      });
    },
    closeAeform(p) {
      this.showAeform = false;
      if (p !== 'unRefresh') {
        this.onLoad();
      }
    },
    openAeform(type, id) {
      if (type === 'edit') {
        this.aeformTitle = '修改';
      } else if (type === 'view') {
        this.aeformTitle = '详情查看';
      } else if (type === 'add') {
        this.aeformTitle = '新增';
      } else if (type === 'copy') {
        this.aeformTitle = '新增';
      }
      this.dataId = id;
      this.operateType = type;
      this.showAeform = true;
    },
    /*    nodeClick(data) {
      this.resetSearch = false;
      this.query.propertyId = data.id;
      this.page.currentPage = 1;
      this.onLoad();
    },*/
    //点击左侧树结构回调
    propertyNodeTreeClick1(node) {
      this.resetSearch = false;
      this.query.propertyId = node[this.treeProps.value];
      this.propertyName = node[this.treeProps.label];
      if (this.propertyAddShowDialogFlag) {
        this.$refs.propertyAddParentNodeSelectRef.blur();
      }
    },
    initData() {
      getProperTree().then(({ data }) => {
        this.treeData = data;
      });
    },
    //树节点过滤
    filterNode(value, data) {
      console.log('filter: ' + data.title);
      if (!value) return true;
      return data[this.treeProps.label].indexOf(value) !== -1;
    },
    //懒加载树结构
    lazyLoadPropertyTree(node, resolve) {
      let id;
      if (node.level === 0) {
        id = 0;
      } else {
        id = node.data.id;
      }

      getTreeChildrenPowerNode({ id: id, power: 1 }).then(({ data }) => {
        resolve(data);
      });
    },
    clearProperty() {
      this.query.propertyId = '';
      this.propertyName = '';
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    stopUse(row) {
      this.$confirm('停用后不可再启用，确定停用?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return stopUse({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.propertyName = '';
      this.resetSearch = true;
      this.onLoad();
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    searchChange(params, done) {
      console.log(JSON.stringify(params));
      if (this.resetSearch) {
        //params.remove('')
        params.propertyId = undefined;
      }
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
  height: auto;
  max-height: 274px;
  line-height: 25px;
  padding-left: 10px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
